<template>
  <div>
    <div
      class="name"
      :class="{
        required: field.required,
      }"
    >
      {{ field.name }}
    </div>
    <div>
      <div v-for="variant in variants" :key="variant.id" class="variant">
        <c-checkbox
          :value="localValue.includes(variant.id)"
          :label="variant.text"
          type="checkbox"
          @input="updateValue($event, variant.id)"
        />
      </div>
    </div>
    <error-feedback v-if="error" :text="error" />
  </div>
</template>

<script>
import CCheckbox from "@/components/controls2/Switcher";
import ErrorFeedback from "@/components/error-feedback";
import { FieldVariant } from "@/domains/profile/models/ProfileFieldVariant";

export default {
  components: { CCheckbox, ErrorFeedback },
  props: ["field", "value", "editable", "error"],
  data() {
    return {
      inited: false,
      localValue: [],
    };
  },
  computed: {
    dictionary() {
      return this.$store.state.profile.dictionaries[this.field.parentId] || [];
    },
    variants() {
      return this.dictionary.map(FieldVariant);
    },
  },
  watch: {
    value(v) {
      this.setData(v);
    },
    localValue(v) {
      this.$emit("input", { value: v });
      if (this.inited) this.$emit("change");
    },
  },
  created() {
    this.$store.dispatch("profile/getDictionary", { fieldId: this.field.parentId });
    if (this.value) this.setData(this.value);
  },
  methods: {
    setData(value) {
      if (!value) return;
      this.inited = false;
      const v = value.value || [];
      if (JSON.stringify(this.localValue) !== JSON.stringify(v)) {
        this.localValue = v;
      }
      this.$nextTick(() => {
        this.inited = true;
      });
    },
    updateValue(event, newValue) {
      if (event) {
        this.localValue = [...this.localValue, newValue];
      } else {
        this.localValue = this.localValue.filter((id) => id !== newValue);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.name {
  font-size: 15px;
  margin-bottom: 16px;
  line-height: 1.4;

  &.required {
    &:after {
      content: "*";
      color: red;
    }
  }
}
.variant:not(:last-child) {
  margin-bottom: 20px;
}
</style>
